module.exports = __webpack_public_path__ + "img/lock.66c78aad.svg";